const ROUTE_TO_SECTION = Object.freeze({
  "/": "home",
  "/home": "home",
  "/sueros": "sueros",
  "/tratamientos": "tratamientos",
  "/empresas": "empresas",
  "/nosotros": "nosotros",
  "/contacto": "contacto",
  "/reservar": "reservar",
});

export function normalizePath(pathname = "/") {
  if (!pathname) return "/";

  const trimmed = pathname.trim().toLowerCase();
  if (!trimmed || trimmed === "/") return "/";

  return trimmed.replace(/\/+$/, "");
}

export function getSectionIdFromPath(pathname = "/") {
  const normalizedPath = normalizePath(pathname);
  if (normalizedPath.startsWith("/sueros/")) return "sueros";
  if (normalizedPath.startsWith("/tratamientos/")) return "tratamientos";
  return ROUTE_TO_SECTION[normalizedPath] || "home";
}

export function isSectionPathActive(currentPathname, targetPathname) {
  return getSectionIdFromPath(currentPathname) === getSectionIdFromPath(targetPathname);
}

export function scrollToSection(sectionId, behavior = "smooth") {
  if (typeof window === "undefined" || typeof document === "undefined") return false;

  const target = document.getElementById(sectionId);
  if (!target) return false;

  const navbar = document.querySelector(".navbar");
  const navbarHeight = navbar ? navbar.getBoundingClientRect().height : 0;
  const offset = 12;
  const top = window.scrollY + target.getBoundingClientRect().top - navbarHeight - offset;

  window.scrollTo({
    top: Math.max(top, 0),
    behavior,
  });

  return true;
}

export function scrollToTop(behavior = "smooth") {
  if (typeof window === "undefined") return false;

  window.scrollTo({
    top: 0,
    behavior,
  });

  return true;
}

export function scrollToPath(pathname, behavior = "smooth") {
  const sectionId = getSectionIdFromPath(pathname);
  return scrollToSection(sectionId, behavior);
}
